/**
 * PDP V7 Ageless Platinum
 * Galerie (Swiper + vignettes), quantite, ajout au panier (AJAX + tiroir du theme),
 * barre d'achat fixe, jauge cadeau, comparateur avant/apres, cremes facultatives,
 * bouton de la section Difference, suivi du lien diagnostic, module d'avis Judge.me
 * charge sur une page (section pdp7-reviews).
 *
 * Contrat avec le theme :
 *  - POST /cart/add.js puis evenements cart:updated / cart:refresh / cart:open
 *    (memes evenements que product-main.js, ecoutes par cart-drawer.js)
 *  - la barre fixe porte [data-sticky-atc] + .is-visible / .is-hidden-by-drawer
 *    (header.js et market-recommendation.js s'y branchent)
 */
(function () {
  'use strict';

  /* Le fichier est inclus par plusieurs sections : une seule execution */
  if (window.__pdp7Loaded) return;
  window.__pdp7Loaded = true;

  var strings = (window.theme && window.theme.strings) || {};
  var STR = {
    adding: strings.adding || 'Ajout en cours...',
    added: strings.added || 'Ajouté !',
    error: strings.error || 'Erreur',
    addToCart: strings.addToCart || 'Ajouter au panier'
  };

  /* Format monetaire : deduit du rendu Liquid de 1234.56 (data-money-sample), donc identique
     au reste de la boutique quel que soit le marche ("CHF 1'234.56", "1.234,56 €", ...). */
  function formatMoney(cents) {
    var main = document.querySelector('[data-pdp7-main]');
    var sample = main && main.dataset.moneySample;
    var amount = Math.round(cents) / 100;
    if (sample) {
      var m = sample.match(/^(.*?)1(\D?)234(\D)56(.*)$/);
      if (m) {
        var prefix = m[1], thousands = m[2], decimal = m[3], suffix = m[4];
        var parts = amount.toFixed(2).split('.');
        var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return prefix + intPart + decimal + parts[1] + suffix;
      }
      var m0 = sample.match(/^(.*?)1(\D?)235(.*)$/);
      if (m0) {
        var intOnly = String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, m0[2]);
        return m0[1] + intOnly + m0[3];
      }
    }
    var currency = (main && main.dataset.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  /* ------------------------------------------------------------
     Panier : un seul point d'entree, memes evenements que le theme
     ------------------------------------------------------------ */
  function addToCart(variantId, quantity) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (data) {
        if (!response.ok) {
          /* 422 Shopify : description localisee et lisible ; sinon message generique */
          var message = data && (data.description || data.message);
          throw new Error(message || STR.error);
        }
        return data;
      });
    }, function () {
      throw new Error(STR.error);
    }).then(function (data) {
      /* cart:updated suffit : le tiroir du theme se rafraichit et s'ouvre dessus */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    });
  }

  function statusKind(el) {
    if (el.classList.contains('pdp7-product-card__status')) return 'pdp7-product-card__status';
    if (el.classList.contains('pdp7-sticky__status')) return 'pdp7-sticky__status';
    return 'pdp7-form__status';
  }

  /* "Ajoute !" s'efface apres ce delai ; un message d'erreur reste affiche */
  var STATUS_SUCCESS_CLEAR = 4000;

  function runButton(button, statusEl, variantId, quantity) {
    if (!button || button.disabled) return Promise.resolve();
    var label = button.dataset.labelDefault || button.textContent.trim();
    button.dataset.labelDefault = label;
    button.disabled = true;
    button.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');
    button.textContent = STR.adding;
    if (statusEl) {
      window.clearTimeout(statusEl._pdp7Clear);
      statusEl.textContent = '';
      statusEl.className = statusEl.className.replace(/\s?pdp7-(form|product-card|sticky)__status--(error|success)/g, '');
    }
    return addToCart(variantId, quantity).then(function () {
      button.textContent = STR.added;
      if (statusEl) {
        statusEl.textContent = STR.added;
        statusEl.classList.add(statusKind(statusEl) + '--success');
        statusEl._pdp7Clear = window.setTimeout(function () {
          statusEl.textContent = '';
          statusEl.classList.remove(statusKind(statusEl) + '--success');
        }, STATUS_SUCCESS_CLEAR);
      }
    }).catch(function (error) {
      button.textContent = STR.error;
      if (statusEl) {
        statusEl.textContent = error && error.message ? error.message : STR.error;
        statusEl.classList.add(statusKind(statusEl) + '--error');
      }
    }).then(function () {
      window.setTimeout(function () {
        button.textContent = label;
        button.disabled = false;
        button.classList.remove('is-busy');
        button.removeAttribute('aria-busy');
      }, 1800);
    });
  }

  /* ------------------------------------------------------------
     Section principale
     ------------------------------------------------------------ */
  function initMain(section) {
    if (!section || section._pdp7) return;
    section._pdp7 = true;

    var form = section.querySelector('[data-pdp7-form]');
    var qtyInput = section.querySelector('[data-pdp7-qty-input]');
    var qtyMinus = section.querySelector('[data-pdp7-qty-minus]');
    var qtyPlus = section.querySelector('[data-pdp7-qty-plus]');
    var atc = section.querySelector('[data-pdp7-atc]');
    var status = section.querySelector('[data-pdp7-status]');
    var variantSelect = section.querySelector('[data-pdp7-variant-select]');
    var variantHidden = section.querySelector('[data-pdp7-variant-id]');
    var priceEl = section.querySelector('[data-pdp7-price]');
    var compareEl = section.querySelector('[data-pdp7-compare-price]');
    var stickyPrice = section.querySelector('[data-pdp7-sticky-price]');
    var stockEl = section.querySelector('[data-pdp7-stock]');
    var stockText = section.querySelector('[data-pdp7-stock-text]');
    var sticky = section.querySelector('[data-pdp7-sticky]');
    var stickyAtc = section.querySelector('[data-pdp7-sticky-atc]');

    function readQuantity() {
      var value = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(value) || value < 1) value = 1;
      if (value > 10) value = 10;
      return value;
    }

    /* Ecrit la valeur normalisee (jamais pendant la frappe, sinon impossible de vider le champ) */
    function getQuantity() {
      var value = readQuantity();
      if (qtyInput) qtyInput.value = String(value);
      return value;
    }

    function syncQtyButtons() {
      var value = readQuantity();
      if (qtyMinus) qtyMinus.disabled = value <= 1;
      if (qtyPlus) qtyPlus.disabled = value >= 10;
    }

    function getVariantId() {
      if (variantSelect) return variantSelect.value;
      if (variantHidden) return variantHidden.value;
      return null;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () { if (qtyInput) qtyInput.value = String(getQuantity() - 1); syncQtyButtons(); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { if (qtyInput) qtyInput.value = String(getQuantity() + 1); syncQtyButtons(); });
    if (qtyInput) {
      qtyInput.addEventListener('input', syncQtyButtons);
      qtyInput.addEventListener('change', function () { getQuantity(); syncQtyButtons(); });
    }
    syncQtyButtons();

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var available = option.dataset.available === 'true';
        var price = parseInt(option.dataset.price, 10);
        var compare = parseInt(option.dataset.compare, 10);
        if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
        if (stickyPrice && !isNaN(price)) stickyPrice.textContent = formatMoney(price);
        if (compareEl) {
          if (!isNaN(compare) && compare > price) {
            compareEl.textContent = formatMoney(compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        var outOfStock = (form && form.dataset.strOutOfStock) || STR.error;
        [atc, stickyAtc].forEach(function (button) {
          if (!button) return;
          button.disabled = !available;
          button.textContent = available ? (button.dataset.labelDefault || STR.addToCart) : outOfStock;
        });
        if (stockEl) stockEl.hidden = available;
        if (stockText) stockText.textContent = outOfStock;
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var variantId = getVariantId();
        if (!variantId) return;
        runButton(atc, status, variantId, getQuantity());
      });
    }

    /* Barre fixe : visible seulement quand le bouton principal est passe sous l'en-tete fixe */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var atcVisible = true;
      var pastButton = false;
      var stickyStatus = section.querySelector('[data-pdp7-sticky-status]');
      var header = document.querySelector('.header');
      var headerBottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      var update = function () {
        var atBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 40;
        var show = !atcVisible && pastButton && !atBottom;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyAtc) stickyAtc.tabIndex = show ? 0 : -1;
      };
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        atcVisible = entry.isIntersecting;
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < headerBottom;
        update();
      }, { threshold: 0, rootMargin: '-' + headerBottom + 'px 0px 0px 0px' });
      observer.observe(atc);

      /* Saut instantane (ancre, touche Debut, retour en haut) : l'observateur ne rappelle
         pas quand le bouton reste hors champ de part et d'autre du saut. On remesure donc
         la position du bouton a l'image suivante, avec les memes regles que l'observateur. */
      var frame = 0;
      var measure = function () {
        frame = 0;
        var rect = atc.getBoundingClientRect();
        if (rect.width || rect.height) {
          atcVisible = rect.bottom > headerBottom && rect.top < window.innerHeight;
          pastButton = !atcVisible && rect.top < headerBottom;
        }
        update();
      };
      window.addEventListener('scroll', function () {
        if (!frame) frame = window.requestAnimationFrame(measure);
      }, { passive: true });

      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          var variantId = getVariantId();
          if (!variantId) return;
          runButton(stickyAtc, stickyStatus || status, variantId, getQuantity());
        });
      }
    }

    /* Jauge cadeau : recalculee apres chaque mise a jour du panier */
    var gift = section.querySelector('[data-pdp7-gift]');
    if (gift) {
      var giftMessage = gift.querySelector('[data-pdp7-gift-message]');
      var giftFill = gift.querySelector('[data-pdp7-gift-fill]');
      var threshold = parseInt(gift.dataset.giftThreshold, 10) || 0;
      var giftTimer = null;
      var refreshGift = function () {
        window.clearTimeout(giftTimer);
        giftTimer = window.setTimeout(fetchGift, 250);
      };
      var fetchGift = function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* Meme base que le tiroir panier : total hors articles cadeau (_gift) */
            var total = (cart.items || []).reduce(function (sum, item) {
              var isGift = item.properties && String(item.properties._gift) === 'true';
              return isGift ? sum : sum + (item.final_line_price || item.line_price || 0);
            }, 0);
            var remaining = threshold - total;
            var progress = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
            if (giftFill) giftFill.style.setProperty('--pdp7-gift-progress', progress + '%');
            if (!giftMessage) return;
            var tpl = gift.dataset;
            if (remaining > 0) {
              giftMessage.innerHTML = '';
              giftMessage.append((tpl.prefix || 'Plus que') + ' ');
              var strong = document.createElement('strong');
              strong.textContent = formatMoney(remaining);
              giftMessage.append(strong, ' ' + (tpl.suffix || 'pour débloquer votre') + ' ');
              var label = document.createElement('strong');
              label.textContent = tpl.label || 'cadeau offert';
              giftMessage.append(label);
            } else {
              giftMessage.innerHTML = '';
              var unlocked = document.createElement('strong');
              unlocked.textContent = tpl.unlocked || 'Votre cadeau offert est débloqué';
              giftMessage.append(unlocked);
            }
          })
          .catch(function () {});
      };
      document.addEventListener('cart:updated', refreshGift);
      document.addEventListener('cart:drawer-refreshed', refreshGift);
    }

    initGallery(section);
  }

  /* ------------------------------------------------------------
     Galerie : Swiper (charge globalement par le theme) + vignettes
     ------------------------------------------------------------ */
  function initGallery(section) {
    var stage = section.querySelector('[data-pdp7-swiper]');
    if (!stage) return;
    var slides = stage.querySelectorAll('[data-pdp7-slide]');
    var thumbs = section.querySelectorAll('[data-pdp7-thumb]');
    var counter = section.querySelector('[data-pdp7-counter]');
    var total = slides.length;

    function selectThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.setAttribute('aria-selected', String(active));
        thumb.tabIndex = active ? 0 : -1;
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + total;
    }

    if (typeof window.Swiper !== 'function' || total < 2) {
      selectThumb(0);
      fitThumbs(section);
      return;
    }

    var swiper = new window.Swiper(stage, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 350,
      watchOverflow: true,
      a11y: { enabled: false },
      pagination: {
        el: section.querySelector('[data-pdp7-dots]'),
        clickable: true,
        bulletElement: 'button',
        renderBullet: function (index, className) {
          return '<button type="button" class="' + className + '" aria-label="' + (index + 1) + ' / ' + total + '"></button>';
        }
      },
      navigation: { prevEl: section.querySelector('[data-pdp7-prev]'), nextEl: section.querySelector('[data-pdp7-next]') },
      on: {
        slideChange: function () { selectThumb(this.realIndex); }
      }
    });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { swiper.slideTo(i); });
      thumb.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % thumbs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + thumbs.length) % thumbs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = thumbs.length - 1;
        if (next === null) return;
        event.preventDefault();
        thumbs[next].focus();
        swiper.slideTo(next);
      });
    });

    selectThumb(0);
    section._pdp7Swiper = swiper;
    fitThumbs(section);
  }

  /* Les miniatures sont le visuel rendu a 640px puis reduit : l'echelle suit la largeur reelle */
  function fitThumbs(section) {
    var visuals = section.querySelectorAll('.pdp7-thumb__visual');
    if (!visuals.length) return;
    var apply = function () {
      visuals.forEach(function (visual) {
        var width = visual.clientWidth;
        if (width > 0) visual.style.setProperty('--pdp7-thumb-scale', (width / 640).toFixed(4));
      });
    };
    apply();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(apply);
      ro.observe(visuals[0]);
    } else {
      window.addEventListener('resize', apply);
    }
  }

  /* ------------------------------------------------------------
     Resultats : comparateur facultatif
     ------------------------------------------------------------ */
  function initResults(section) {
    if (!section || section._pdp7) return;
    section._pdp7 = true;
    var pair = section.querySelector('[data-pdp7-pair]');
    var compare = section.querySelector('[data-pdp7-compare]');
    var toggle = section.querySelector('[data-pdp7-compare-toggle]');
    var range = section.querySelector('[data-pdp7-compare-range]');
    if (compare && range) {
      var apply = function () { compare.style.setProperty('--pdp7-compare-pos', range.value + '%'); };
      range.addEventListener('input', apply);
      apply();
    }
    if (toggle && pair && compare) {
      toggle.addEventListener('click', function () {
        var showCompare = compare.hidden;
        compare.hidden = !showCompare;
        pair.hidden = showCompare;
        toggle.setAttribute('aria-pressed', String(showCompare));
        toggle.textContent = showCompare ? (toggle.dataset.labelPair || toggle.textContent) : (toggle.dataset.labelCompare || toggle.textContent);
        if (showCompare && range) range.focus({ preventScroll: true });
      });
    }
  }

  /* ------------------------------------------------------------
     Cremes facultatives : ajout unitaire, aucune preselection.
     Sert aussi au bouton de la section Difference (meme formulaire de carte).
     ------------------------------------------------------------ */
  function initRoutine(section) {
    if (!section || section._pdp7) return;
    section._pdp7 = true;
    section.querySelectorAll('[data-pdp7-card-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[data-pdp7-card-atc]');
        var status = form.querySelector('[data-pdp7-card-status]');
        var input = form.querySelector('input[name="id"]');
        if (!button || !input) return;
        runButton(button, status, input.value, 1);
      });
    });
  }

  /* ------------------------------------------------------------
     Aide au choix : mesure du clic, jamais assimile a une vente
     ------------------------------------------------------------ */
  function initHelp(section) {
    if (!section || section._pdp7) return;
    section._pdp7 = true;
    var link = section.querySelector('[data-pdp7-diagnostic-link]');
    if (!link) return;
    link.addEventListener('click', function () {
      var payload = { source: section.dataset.source || 'pdp-v7', product: section.dataset.product || '', href: link.href };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('pdp7_diagnostic_click', payload);
        }
      } catch (e) { /* silencieux */ }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'pdp7_diagnostic_click', pdp7: payload });
      document.dispatchEvent(new CustomEvent('pdp7:diagnostic-click', { detail: payload }));
    });
  }

  /* ------------------------------------------------------------
     Avis Judge.me sur une page (section pdp7-reviews)
     Le bloc d'application Judge.me ne rend rien hors fiche produit. On charge donc,
     a l'approche du viewport, le module rendu par le template produit sans layout
     (/products/<handle>?view=lp-avis), on l'insere avec ses scripts de donnees, puis on
     relance le chargeur Judge.me deja present dans la page. Le resume de note et le lien
     vers la fiche restent visibles tant que le module n'est pas monte (echec, delai).
     ------------------------------------------------------------ */
  var JDGM_GIVE_UP = 60000;
  var JDGM_MOUNTED = '.jdgm--done-setup-widget, .jdgm-widget-revamp';

  function initReviews(section) {
    if (!section || section._pdp7) return;
    section._pdp7 = true;
    var host = section.querySelector('[data-pdp7-jdgm]');
    if (!host || !host.dataset.src || !window.fetch || !window.DOMParser) return;

    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      loadJudgeme(section, host);
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            start();
            return;
          }
        }
      }, { rootMargin: '800px 0px' });
      io.observe(section);
    } else {
      start();
    }
  }

  function loadJudgeme(section, host) {
    var done = false;
    var giveUpTimer = null;
    var observer = null;
    /* Module revamp actif (jdgmSettings.review_widget_revamp_enabled) : seul
       .jdgm-widget-revamp signifie "affiche". La classe jdgm--done-setup-widget est posee
       par les scripts historiques que le chargeur relance aussi, avant le rendu revamp. */
    var settings = window.jdgmSettings || {};
    var mountedSelector = settings.review_widget_revamp_enabled ? '.jdgm-widget-revamp' : JDGM_MOUNTED;

    function finish(mounted) {
      if (done) return;
      done = true;
      window.clearTimeout(giveUpTimer);
      if (observer) observer.disconnect();
      if (mounted) {
        section.classList.add('is-loaded');
        document.dispatchEvent(new CustomEvent('pdp7:reviews-mounted', { detail: { section: section } }));
      }
    }

    function check() {
      if (host.querySelector(mountedSelector)) finish(true);
    }

    fetch(host.dataset.src, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        /* Un seul module par page : l'id judgeme_product_reviews doit rester unique */
        if (document.getElementById('judgeme_product_reviews')) throw new Error('duplicate');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var widget = doc.getElementById('judgeme_product_reviews');
        if (!widget) throw new Error('widget');

        /* Scripts de donnees voisins du module (jdgm.data.reviewWidget), sans le JSON-LD */
        var scripts = [];
        var siblings = widget.parentNode ? widget.parentNode.children : [];
        for (var i = 0; i < siblings.length; i++) {
          var type = (siblings[i].getAttribute('type') || '').toLowerCase();
          if (siblings[i].tagName === 'SCRIPT' && type !== 'application/ld+json') scripts.push(siblings[i]);
        }

        if ('MutationObserver' in window) {
          observer = new MutationObserver(check);
          observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        }
        /* Pas de verdict definitif a 10 s : le secours reste affiche tant que le module
           n'est pas monte, et un montage tardif (reseau lent) pose encore is-loaded.
           L'observateur n'est coupe qu'apres JDGM_GIVE_UP. */
        giveUpTimer = window.setTimeout(function () { finish(false); }, JDGM_GIVE_UP);

        host.appendChild(document.importNode(widget, true));

        /* Les scripts importes ne s'executent pas : on les recree a l'identique */
        window.jdgm = window.jdgm || {};
        scripts.forEach(function (source) {
          var script = document.createElement('script');
          var type = source.getAttribute('type');
          if (type) script.type = type;
          script.textContent = source.textContent;
          host.appendChild(script);
        });

        /* Chargeur deja passe (page sans module) : on le relance sur le module insere.
           Sinon, le chargeur (defer) trouvera le module lui-meme. */
        if (window.jdgm._loaderExecuted) {
          var loader = document.querySelector('script[src*="judgeme"][src*="/loader.js"]');
          if (loader) {
            window.jdgm._loaderExecuted = false;
            var again = document.createElement('script');
            /* Meme URL que le chargeur deja execute : servie par le cache HTTP, aucun
               telechargement de plus (un script classique reinsere s'execute a nouveau) */
            again.src = loader.getAttribute('src');
            again.setAttribute('data-pdp7-rerun', '');
            again.onerror = function () { finish(false); };
            document.body.appendChild(again);
          }
        }
        check();
      })
      .catch(function () {
        finish(false);
      });
  }

  /* ------------------------------------------------------------
     Initialisation + editeur de theme
     ------------------------------------------------------------ */
  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-pdp7-main]').forEach(initMain);
    root.querySelectorAll('[data-pdp7-results]').forEach(initResults);
    root.querySelectorAll('[data-pdp7-routine]').forEach(initRoutine);
    root.querySelectorAll('[data-pdp7-help]').forEach(initHelp);
    root.querySelectorAll('[data-pdp7-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var details = target.closest('details.pdp7-accordion__item');
    if (details) details.open = true;
    var slide = target.closest('[data-pdp7-slide]');
    if (!slide) return;
    var section = slide.closest('[data-pdp7-main]');
    var index = parseInt(slide.dataset.pdp7Slide, 10) - 1;
    if (section && section._pdp7Swiper && index >= 0) section._pdp7Swiper.slideTo(index);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var details = target.closest('details.pdp7-accordion__item');
    if (details && !details.hasAttribute('data-open-default')) details.open = false;
  });
})();
